module.exports = __webpack_public_path__ + "img/fog.a48619c0.svg";